import type { FormContextType } from 'domains/forms/forms.types'
import { createContext } from 'preact'

const FormContext = createContext<FormContextType>({
  handleSubmit: () => undefined,
  isSubmitted: false,
  isValid: false,
  updateControlValue: () => undefined,
  updateControlTouched: () => undefined,
  errors: undefined,
})

export const { Provider, Consumer } = FormContext

export default FormContext
